module.exports = __webpack_public_path__ + "img/platform-monitoring-data-mangment.03b105ff.png";